import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import CompareDemo from "@/components/CompareDemo";
import PaymentOptionsSection from "@/components/PaymentOptionsSection";
import MonthlyCalculatorSection from "@/components/MonthlyCalculatorSection";
import WhyFlexauraSection from "@/components/WhyFlexauraSection";
import PartnerLogos from "@/components/PartnerLogos";
import VerticalCardsSection from "@/components/VerticalCardsSection";
import FAQSection from "@/components/FAQSection";
import PartnerForm from "@/components/PartnerForm";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ComplianceNote from "@/components/ComplianceNote";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import CookieConsent from "@/components/CookieConsent";
import AskFlexaura from "@/components/ai/AskFlexaura";
import TrustBadges from "@/components/TrustBadges";
import { suggestFinancePlans } from "@/lib/finance-plans";

const Index = () => {
  // Sample context and plans for the homepage copilot
  const financeAmount = 50000;
  const financeOptions = suggestFinancePlans({
    vertical: "education",
    amountAED: financeAmount,
    context: { level: "primary", termCount: 3, enrolled: true }
  });

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>
        <HeroSection />
        <TrustBadges />
        
        {/* Add colorful background sections */}
        <HowItWorksSection />
        <CompareDemo />
        
        <div className="bg-gradient-to-r from-accent/10 to-primary/10">
          <PaymentOptionsSection />
        </div>
        
        <div className="bg-gradient-to-bl from-primary/5 via-background to-accent/5">
          <MonthlyCalculatorSection />
        </div>
        
        <div className="bg-gradient-to-r from-accent/5 via-primary/5 to-accent/10 relative overflow-hidden">
          {/* Add decorative elements */}
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
          <div className="relative">
            <WhyFlexauraSection />
          </div>
        </div>
        
        <PartnerLogos />
        
        <div className="bg-gradient-to-r from-accent/10 via-primary/5 to-accent/5 relative">
          <div className="relative">
            <VerticalCardsSection />
          </div>
        </div>
        
        <FAQSection />
        
        <PartnerForm />
        
        <div className="gradient-bg">
          <CTASection />
        </div>
      </main>
      <ComplianceNote />
      <Footer />
      <StickyMobileCTA />
      <CookieConsent />
      <AskFlexaura 
        context={{ vertical: "education", amountAED: financeAmount }}
        plans={financeOptions}
      />
    </div>
  );
};

export default Index;